import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select'

export default class extends Controller {
  connect() {
    // Si el elemento está dentro de un modal, esperar a que el modal se muestre
    const modal = this.element.closest('.modal')
    if (modal) {
      // Esperar a que el modal se muestre completamente
      const initSelect = () => {
        if (!this.slimSelectInstance) {
          this.slimSelectInstance = new SlimSelect({
            select: this.element,
            settings: {
              showSearch: true,
              searchPlaceholder: 'Buscar...'
            },
            events: {
              afterChange: (newVal) => {
                // Disparar evento change en el select original para que Stimulus lo capture
                const changeEvent = new Event('change', { bubbles: true })
                this.element.dispatchEvent(changeEvent)
              }
            }
          })
          // Guardar la instancia también en el elemento para acceso directo
          this.element.slimSelect = this.slimSelectInstance
        }
      }

      // Si el modal ya está visible, inicializar inmediatamente
      if (modal.classList.contains('show')) {
        initSelect()
      } else {
        // Esperar al evento shown.bs.modal
        modal.addEventListener('shown.bs.modal', initSelect, { once: true })
        // También intentar inicializar después de un pequeño delay por si acaso
        setTimeout(initSelect, 100)
      }
    } else {
      // Si no está en un modal, inicializar normalmente
      this.slimSelectInstance = new SlimSelect({
        select: this.element,
        settings: {
          showSearch: true,
          searchPlaceholder: 'Buscar...'
        },
        events: {
          afterChange: (newVal) => {
            // Disparar evento change en el select original para que Stimulus lo capture
            const changeEvent = new Event('change', { bubbles: true })
            this.element.dispatchEvent(changeEvent)
          }
        }
      })
      // Guardar la instancia también en el elemento para acceso directo
      this.element.slimSelect = this.slimSelectInstance
    }
  }

  // NO incluir disconnect() - podría causar freeze similar a choices_controller.js

  initializeSlimSelect() {
    // Verificar si ya está inicializado y destruirlo primero
    if (this.element.slimSelect) {
      try {
        this.element.slimSelect.destroy()
      } catch (e) {
        // Ignorar errores al destruir
      }
      delete this.element.slimSelect
    }

    // Verificar que el elemento tenga opciones antes de inicializar
    if (this.element.options.length === 0) {
      // Si no hay opciones, esperar un poco y reintentar
      setTimeout(() => {
        this.initializeSlimSelect()
      }, 100)
      return
    }

    try {
      const slimSelect = new SlimSelect({
        select: this.element,
        placeholder: this.element.getAttribute('data-placeholder') || 'Seleccionar...',
        allowDeselect: true,
        closeOnSelect: false
      })

      // Guardar referencia para poder destruirla después
      this.element.slimSelect = slimSelect
    } catch (error) {
      console.error('Error initializing SlimSelect:', error)
    }
  }

  // NO incluir disconnect() - podría causar freeze similar a choices_controller.js
}
